import { render, staticRenderFns } from "./LostPassword.vue?vue&type=template&id=359dc824&scoped=true&"
import script from "./LostPassword.vue?vue&type=script&lang=js&"
export * from "./LostPassword.vue?vue&type=script&lang=js&"
import style0 from "./LostPassword.vue?vue&type=style&index=0&id=359dc824&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359dc824",
  null
  
)

export default component.exports